module.exports = __webpack_public_path__ + "img/cgr_ba.761d2edf.jpg";